<div
  *ngIf="open"
  class="cv-af-backdrop"
  role="dialog"
  aria-modal="true"
  aria-label="Attribute Filter"
  (click)="onBackdropClick($event)"
>
  <div class="cv-af-modal">
    <!-- Header -->
    <div class="cv-af-modal__header">
      <span class="cv-af-modal__title">Attribute Filter</span>
      <span *ngIf="dataset" class="cv-af-modal__subtitle">{{ dataset.name }}</span>
      <button
        type="button"
        class="cv-af-modal__close"
        (click)="onClose()"
        aria-label="Close"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading()" class="cv-af-modal__loading">
      <span class="cv-af-modal__spinner" aria-hidden="true"></span>
      <span>Loading attributes…</span>
    </div>

    <!-- Error -->
    <div *ngIf="!loading() && error()" class="cv-af-modal__error">
      {{ error() }}
    </div>

    <!-- Attribute rows -->
    <div *ngIf="!loading() && !error() && rows().length > 0" class="cv-af-modal__body">
      <p class="cv-af-modal__hint">
        Check an attribute and enter a value to filter dataset features.
      </p>
      <div class="cv-af-modal__rows">
        <div
          *ngFor="let row of rows()"
          class="cv-af-row"
          [class.cv-af-row--checked]="isChecked(row.key)"
        >
          <label class="cv-af-row__label">
            <input
              type="checkbox"
              class="cv-af-row__check"
              [checked]="isChecked(row.key)"
              (change)="toggleKey(row.key)"
            />
            <span class="cv-af-row__key">{{ row.key }}</span>
            <span *ngIf="row.dataSchema" class="cv-af-row__schema">{{ row.dataSchema }}</span>
          </label>
          <ng-container *ngIf="isChecked(row.key) && row.isDateTime">
            <div class="cv-af-row__datetime-modes">
              <label class="cv-af-row__mode">
                <input
                  type="radio"
                  [name]="'dt-mode-' + row.key"
                  [checked]="getDatetimeMode(row.key) === 'equal'"
                  (change)="setDatetimeMode(row.key, 'equal')"
                />
                Equal
              </label>
              <label class="cv-af-row__mode">
                <input
                  type="radio"
                  [name]="'dt-mode-' + row.key"
                  [checked]="getDatetimeMode(row.key) === 'after'"
                  (change)="setDatetimeMode(row.key, 'after')"
                />
                After
              </label>
              <label class="cv-af-row__mode">
                <input
                  type="radio"
                  [name]="'dt-mode-' + row.key"
                  [checked]="getDatetimeMode(row.key) === 'before'"
                  (change)="setDatetimeMode(row.key, 'before')"
                />
                Before
              </label>
              <label class="cv-af-row__mode">
                <input
                  type="radio"
                  [name]="'dt-mode-' + row.key"
                  [checked]="getDatetimeMode(row.key) === 'interval'"
                  (change)="setDatetimeMode(row.key, 'interval')"
                />
                Interval
              </label>
            </div>
            <ng-container *ngIf="getDatetimeMode(row.key) === 'interval'; else singleDt">
              <input
                type="datetime-local"
                class="cv-af-row__input"
                [value]="getDatetimeFrom(row.key)"
                (input)="setDatetimeFrom(row.key, $any($event.target).value)"
              />
              <input
                type="datetime-local"
                class="cv-af-row__input"
                [value]="getDatetimeTo(row.key)"
                (input)="setDatetimeTo(row.key, $any($event.target).value)"
              />
            </ng-container>
            <ng-template #singleDt>
              <input
                type="datetime-local"
                class="cv-af-row__input"
                [value]="getDatetimeSingle(row.key)"
                (input)="setDatetimeSingle(row.key, $any($event.target).value)"
              />
            </ng-template>
          </ng-container>
          <input
            *ngIf="isChecked(row.key) && !row.isDateTime"
            type="text"
            class="cv-af-row__input"
            [placeholder]="row.description || ('Filter by ' + row.key)"
            [value]="getValue(row.key)"
            (input)="setValue(row.key, $any($event.target).value)"
          />
          <p *ngIf="isChecked(row.key) && row.description" class="cv-af-row__desc">
            {{ row.description }}
          </p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div *ngIf="!loading() && !error()" class="cv-af-modal__footer">
      <button type="button" class="cv-af-modal__cancel" (click)="onClose()">
        Cancel
      </button>
      <button
        type="button"
        class="cv-af-modal__apply"
        [disabled]="!hasSelection()"
        (click)="onApply()"
      >
        Apply Filter
      </button>
    </div>
  </div>
</div>
